/**
 * 验证手机号
 */
export function validatePhone(phone) {
  const phoneRegex = /^1[3-9]\d{9}$/
  return phoneRegex.test(phone)
}

/**
 * 验证邮箱
 */
export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

/**
 * 验证身份证号
 */
export function validateIdCard(idCard) {
  const idCardRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
  return idCardRegex.test(idCard)
}

/**
 * 验证必填字段
 */
export function validateRequired(value) {
  if (typeof value === 'string') {
    return value.trim().length > 0
  }
  return value !== null && value !== undefined && value !== ''
}

/**
 * 验证最小长度
 */
export function validateMinLength(value, min) {
  if (typeof value === 'string') {
    return value.length >= min
  }
  return false
}

/**
 * 验证最大长度
 */
export function validateMaxLength(value, max) {
  if (typeof value === 'string') {
    return value.length <= max
  }
  return false
}

/**
 * 验证数字范围
 */
export function validateRange(value, min, max) {
  const num = parseFloat(value)
  return !isNaN(num) && num >= min && num <= max
}

/**
 * 验证表单
 */
export function validateForm(form, rules) {
  const errors = {}

  for (const field in rules) {
    const rule = rules[field]
    const value = form[field]

    if (rule.required && !validateRequired(value)) {
      errors[field] = rule.message || `${field} 是必填项`
      continue
    }

    if (rule.type === 'phone' && value && !validatePhone(value)) {
      errors[field] = rule.message || '请输入有效的手机号'
      continue
    }

    if (rule.type === 'email' && value && !validateEmail(value)) {
      errors[field] = rule.message || '请输入有效的邮箱'
      continue
    }

    if (rule.type === 'idCard' && value && !validateIdCard(value)) {
      errors[field] = rule.message || '请输入有效的身份证号'
      continue
    }

    if (rule.minLength && value && !validateMinLength(value, rule.minLength)) {
      errors[field] = rule.message || `${field} 最少需要 ${rule.minLength} 个字符`
      continue
    }

    if (rule.maxLength && value && !validateMaxLength(value, rule.maxLength)) {
      errors[field] = rule.message || `${field} 最多只能 ${rule.maxLength} 个字符`
      continue
    }
  }

  return {
    valid: Object.keys(errors).length === 0,
    errors
  }
}
